// import * as moment from 'moment'

addEventListener('turbolinks:load', event => {
  // console.log(event)
  // console.log(moment([2007, 0, 29]).fromNow())
})
